// Self-contained data for the PQ Jewelries & Accessories concept website.
export const BIZ = {
  name: "PQ Jewelries & Accessories",
  brand: "PQ JEWELRIES",
  sub: "Jewelries & Accessories Shop — Dumaguete",
  tagline: "Gold, Silver & Original Watches, with Easy Layaway",
  intro:
    "We're PQ Jewelries & Accessories, a Dumaguete shop selling 18K and 21K gold, 92.5 silver and original branded watches — with an easy layaway plan for bigger purchases.",
  location: "Dumaguete City, Negros Oriental (Cervantes / JP Teves area)",
  facebook: "https://www.facebook.com/pqjwelries/",
  instagram: "https://www.instagram.com/p/DUaRaXIEs5O/",
  rating: "5.0",
  reviewCount: 5,
  mapEmbed: "https://www.google.com/maps?q=Dumaguete+City+Negros+Oriental&output=embed",
};

export const HIGHLIGHTS = [
  { title: "18K & 21K Gold", text: "Including 21K Saudi gold and 21K Japan gold pieces." },
  { title: "92.5 Silver", text: "Sterling silver jewelry alongside our gold selection." },
  { title: "Original Branded Watches", text: "Casio, Seiko, Alba and more, sold as genuine originals." },
  { title: "Easy Layaway Plan", text: "Ask us about our layaway option for bigger purchases." },
];

export const PRODUCTS = [
  { name: "Seiko 5 Automatic Pair", desc: "Gold-tone and two-tone Seiko 5 automatic watches, 21 jewels.", img: "/pqjewelries/prod-seiko-pair.jpg" },
  { name: "Casio & Alba Collection", desc: "A wide wall display of Casio, Alba and Baby-G watches, analog and digital.", img: "/pqjewelries/prod-watch-wall.jpg" },
  { name: "Casio Gold-Tone Classic", desc: "Simple gold-tone Casio dress watch with date window.", img: "/pqjewelries/prod-casio-gold.jpg" },
];

export const STEPS = [
  { n: "1", title: "Visit or Browse", text: "Drop by the shop or check our Facebook page for current stock." },
  { n: "2", title: "Ask", text: "Ask staff about gold purity (18K/21K), silver content, or watch authenticity." },
  { n: "3", title: "Layaway or Buy", text: "Pay in full, or ask about the easy layaway plan for bigger pieces." },
  { n: "4", title: "Collect", text: "Pick up in-store once payment terms are complete." },
];
